import { Box, Tooltip, Typography } from '@mui/material';
import { formatNumber, NumberFormatPreset, QuickViewWidget, useScrollIntoView } from '@procureai/ui-mui';

import { CubeChart, CubeChartType } from '~/components/CubeChart';
import { monthsInYearFormatter } from '~/components/CubeChart/CubeChart.common';
import { PlaceholderWidget } from '~/components/PlaceholderWidget/PlaceholderWidget';

import { usePercentageOfDemandsWithRecommendationsCubeQuery } from './PercentageOfDemandsWithRecommendationsWidget.hooks';

const formatValueCompactPercent = formatNumber(NumberFormatPreset.PERCENT_DECIMAL);
const formatValueCompactInt = formatNumber(NumberFormatPreset.INTEGER_COMPACT);
const formatValueInt = formatNumber(NumberFormatPreset.INTEGER);

export const PercentageOfDemandsWithRecommendationsWidget = () => {
  const [widgetRef, active] = useScrollIntoView({ hash: 'percent-of-demands-with-recommendations-widget' });
  const { title, subTitle, chartCaptionTooltip, queryValue, chartCaption, isLoading, totalValue } =
    usePercentageOfDemandsWithRecommendationsCubeQuery();

  const isDataEmpty = queryValue.resultSet?.series().length === 0;

  return (
    <QuickViewWidget
      ref={widgetRef}
      active={active}
      loading={isLoading}
      title={title}
      subTitle={subTitle}
      value={formatValueCompactInt(totalValue)}
      valueTooltip={formatValueInt(totalValue)}
      data-intercom-target="PercentOfDemandsWithRecommendations"
    >
      {!isDataEmpty ? (
        <Box
          sx={{
            display: 'flex',
            flex: '1 1 0',
            alignItems: 'flex-end',
          }}
        >
          <Box
            sx={{
              flex: '1 1 0',
              display: 'flex',
              mb: '-5px',
              mr: 3,
            }}
          >
            <Tooltip title={chartCaptionTooltip}>
              <Typography component="div" variant="caption" color="textPrimary">
                {chartCaption}
              </Typography>
            </Tooltip>
          </Box>
          <CubeChart
            type={CubeChartType.tinyBar}
            formatter={{
              x: monthsInYearFormatter,
              y: formatValueCompactPercent,
            }}
            {...queryValue}
          />
        </Box>
      ) : (
        <PlaceholderWidget />
      )}
    </QuickViewWidget>
  );
};
